export interface Batcher<T extends string = string> {
  touch(topic: T): void;
}

// 블러킹으로 구독설정이 여러번 연달아 변경되었을 때
// (렌더트리상 떨어져있는 여러 컴포넌트가 각각 구독설정을 변경하는 경우 등)
// 최종적으로 변경된 구독설정으로 한번만 업데이트하도록 도와줌
export function createBatcher<T extends string = string>(
  updateFn: (dirtyTopics: T[]) => void,
  calcHash: (topic: T) => string,
): Batcher<T> {
  type Hashes = Record<T, string>;
  interface BatchSession {
    oldHashes: Hashes;
    timeoutId: ReturnType<typeof setTimeout>;
  }
  let batchSession: BatchSession | undefined;
  function touch(tableTopic: T): void {
    if (!batchSession) {
      batchSession = {
        oldHashes: {} as Hashes,
        timeoutId: setTimeout(() => {
          const oldHashes = batchSession?.oldHashes;
          if (!oldHashes) return;
          const dirtyTopics = Object.entries(oldHashes)
            .map(([topic, oldHash]) => {
              const newHash = calcHash(topic as T);
              return oldHash !== newHash ? topic : null;
            })
            .filter(Boolean) as T[];
          if (dirtyTopics.length > 0) updateFn(dirtyTopics);
          batchSession = undefined;
        }, 0),
      };
    }
    if (!(tableTopic in batchSession.oldHashes)) {
      batchSession.oldHashes[tableTopic] = calcHash(tableTopic);
    }
  }
  return { touch };
}
